export function getJsonpName(name: string): string {
  name = name
    .replace(/[_-][a-z]/gi, (c) => c[1].toUpperCase())
    .replace(/-/g, '_');

  return `${name}Jsonp`;
}
